import http from "./http";
import { md5 } from "../utils/md5";

export const login = (payload) => http.post("/auth/login", { ...payload, password: md5(payload.password) });
export const loginAdminVerify = (payload) => http.post("/auth/login/admin-verify", payload);
export const sendAuthSmsCode = (payload) => http.post("/auth/sms/send", payload);
export const resetPasswordBySms = (payload) =>
  http.post("/auth/password/reset-by-sms", { ...payload, new_password: md5(payload.new_password) });
export const fetchCaptcha = () => http.get("/auth/captcha");
export const fetchMyProfile = () => http.get("/auth/me");
export const updateMyProfile = (payload) => http.put("/auth/me", payload);
export const changeMyPassword = (payload) =>
  http.post("/auth/change-password", {
    old_password: md5(payload.old_password),
    new_password: md5(payload.new_password),
  });
export const fetchDashboard = () => http.get("/dashboard/overview");
export const fetchDashboardDetails = () => http.get("/dashboard/details");
export const fetchOrders = (params) => http.get("/orders", { params });
export const fetchOrderStatusCounts = (params) => http.get("/orders/status-counts", { params });
export const exportOrders = (params) => http.get("/orders/export", { params, responseType: "text" });
export const batchExportOrders = (payload) => http.post("/orders/batch/export", payload, { responseType: "text" });
export const downloadOrderImportTemplate = () => http.get("/orders/import-template", { responseType: "blob" });
export const importOrders = (formData) =>
  http.post("/orders/import", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 10 * 60 * 1000,
  });
export const createOrder = (payload) => http.post("/orders", payload);
export const updateOrder = (orderId, payload) => http.put(`/orders/${orderId}`, payload);
export const deleteOrder = (orderId) => http.delete(`/orders/${orderId}`);
export const assignOrder = (orderId, payload) => http.post(`/orders/${orderId}/assign`, payload);
export const batchAssignOrders = (payload) => http.post("/orders/batch/assign", payload);
export const reviewOrder = (orderId, payload) => http.post(`/orders/${orderId}/review`, payload);
export const changeStatus = (orderId, payload) => http.post(`/orders/${orderId}/status`, payload);
export const batchChangeOrdersStatus = (payload) => http.post("/orders/batch/status", payload);
export const batchMarkOrdersUrgent = (payload) => http.post("/orders/batch/urgent", payload);
export const batchPublishOrders = (payload) => http.post("/orders/batch/publish", payload);
export const fetchCouriers = () => http.get("/orders/couriers");
export const fetchLocationSettings = () => http.get("/location/settings");
export const updateLocationSettings = (payload) => http.put("/location/settings", payload);
export const courierHeartbeat = () => http.post("/location/courier/heartbeat");
export const fetchSalesUsers = () => http.get("/orders/sales-users");
export const fetchAuditLogs = (params) => http.get("/orders/audit-logs", { params });
export const uploadAttachment = (orderId, payload) => http.post(`/orders/${orderId}/attachments`, payload);
export const fetchOrderDetail = (orderId) => http.get(`/orders/${orderId}`);
export const uploadFile = (formData) =>
  http.post("/orders/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const fetchProvinces = () => http.get("/regions/provinces");
export const fetchCities = (parentId) => http.get("/regions/cities", { params: { parent_id: parentId } });
export const fetchDistricts = (parentId) => http.get("/regions/districts", { params: { parent_id: parentId } });
export const fetchStreets = (parentId) => http.get("/regions/streets", { params: { parent_id: parentId } });

export const fetchUsers = (params) => http.get("/users", { params });
export const fetchLeaders = () => http.get("/users/leaders");
export const createUser = (payload) =>
  http.post("/users", payload.password ? { ...payload, password: md5(payload.password) } : payload);
export const updateUser = (userId, payload) =>
  http.put(`/users/${userId}`, payload.password ? { ...payload, password: md5(payload.password) } : payload);
export const updateUserPassword = (userId, password) => http.put(`/users/${userId}/password`, { password: md5(password) });
export const unbindUserMiniWechat = (userId) => http.post(`/users/${userId}/mini-wechat/unbind`);
export const auditCourier = (userId, payload) => http.post(`/users/${userId}/courier-audit`, payload);
export const unlockUser = (userId) => http.post(`/users/${userId}/unlock`);
export const deleteUser = (userId) => http.delete(`/users/${userId}`);

export const fetchBusinessTypes = (params) => http.get("/catalogs/business-types", { params });
export const createBusinessType = (payload) => http.post("/catalogs/business-types", payload);
export const updateBusinessType = (id, payload) => http.put(`/catalogs/business-types/${id}`, payload);
export const deleteBusinessType = (id) => http.delete(`/catalogs/business-types/${id}`);

export const fetchPaymentTypes = (params) => http.get("/catalogs/payment-types", { params });
export const createPaymentType = (payload) => http.post("/catalogs/payment-types", payload);
export const updatePaymentType = (id, payload) => http.put(`/catalogs/payment-types/${id}`, payload);
export const deletePaymentType = (id) => http.delete(`/catalogs/payment-types/${id}`);

export const fetchProducts = (params) => http.get("/catalogs/products", { params });
export const createProduct = (payload) => http.post("/catalogs/products", payload);
export const updateProduct = (id, payload) => http.put(`/catalogs/products/${id}`, payload);
export const deleteProduct = (id) => http.delete(`/catalogs/products/${id}`);

export const fetchOrderSources = (params) => http.get("/catalogs/order-sources", { params });
export const createOrderSource = (payload) => http.post("/catalogs/order-sources", payload);
export const updateOrderSource = (id, payload) => http.put(`/catalogs/order-sources/${id}`, payload);
export const deleteOrderSource = (id) => http.delete(`/catalogs/order-sources/${id}`);

export const fetchUpstreamApps = (params) => http.get("/catalogs/upstream-apps", { params });
export const createUpstreamApp = (payload) => http.post("/catalogs/upstream-apps", payload);
export const updateUpstreamApp = (id, payload) => http.put(`/catalogs/upstream-apps/${id}`, payload);
export const deleteUpstreamApp = (id) => http.delete(`/catalogs/upstream-apps/${id}`);

export const fetchManualOrderFieldSettings = () => http.get("/manual-order-settings");
export const updateManualOrderFieldSettings = (payload) => http.put("/manual-order-settings", payload);

export const fetchAdminRelations = (params) => http.get("/admin-relations", { params });
export const updateAdminRelations = (adminId, payload) => http.put(`/admin-relations/${adminId}`, payload);

export const fetchIpBlacklist = (params) => http.get("/security/ip-blacklist", { params });
export const createIpBlacklist = (payload) => http.post("/security/ip-blacklist", payload);
export const deleteIpBlacklist = (id) => http.delete(`/security/ip-blacklist/${id}`);
export const fetchLoginAlerts = (params) => http.get("/security/login-alerts", { params });
export const fetchLoginLogs = (params) => http.get("/security/login-logs", { params });
export const fetchOperationLogs = (params) => http.get("/security/operation-logs", { params });
export const fetchUpstreamApiLogs = (params) => http.get("/security/upstream-api-logs", { params });
export const handleLoginAlert = (id) => http.post(`/security/login-alerts/${id}/handled`);

export const fetchSmsTemplates = (params) => http.get("/sms/templates", { params });
export const createSmsTemplate = (payload) => http.post("/sms/templates", payload);
export const updateSmsTemplate = (id, payload) => http.put(`/sms/templates/${id}`, payload);
export const submitSmsTemplate = (id) => http.post(`/sms/templates/${id}/submit`);
export const fetchSmsSendLogs = (params) => http.get("/sms/logs", { params });
export const sendSmsTest = (payload) => http.post("/sms/send-test", payload);

export const fetchAdminRetentionSettings = () => http.get("/admin-retention");
export const updateAdminRetentionSettings = (payload) => http.put("/admin-retention", payload);

export const fetchPublicSystemSettings = () => http.get("/system-settings/public");
export const fetchSystemPermissions = () => http.get("/system-settings/permissions");
export const fetchSystemSettings = () => http.get("/system-settings");
export const updateSystemSettings = (payload) => http.put("/system-settings", payload);
export const generateCourierRegisterQrcode = (payload) => http.post("/system-settings/courier-register-qrcode", payload);
